import React from 'react';

import GaugeIcon from 'src/assets/icons/gauge.svg';
import InsightIcon from 'src/assets/icons/insight.svg';
import GroupIcon from 'src/assets/icons/group.svg';
import SettingsIcon from 'src/assets/icons/setting.svg';
import RecordIcon from 'src/assets/icons/record.svg';
import SquareIcon from 'src/assets/icons/square.svg';
import ParkedIcon from 'src/assets/icons/parked.svg';

const pages = [
  {
    name: 'Overview',
    link: '/overview/',
    icon: <GaugeIcon />,
  },
  {
    name: 'Insights',
    link: '/insights/',
    icon: <InsightIcon />,
  },
  {
    name: 'Group Performance',
    link: '/group-performance/',
    icon: <GroupIcon />,
  },
  {
    name: 'Settings',
    icon: <SettingsIcon />,
    subPages: [
      { name: 'Integrations', link: '/settings/integrations/' },
      { name: 'Routing Rules', link: '/settings/routing-rules/' },
      { name: 'Advanced Settings', link: '/settings/advance-settings/' },
      { name: 'Users', link: '/settings/users/' },
    ],
  },
  {
    name: 'Call Recordings',
    link: '/call-recordings/',
    icon: <RecordIcon />,
  },
  {
    name: 'Parked calls',
    link: '/parked-calls/',
    icon: <ParkedIcon />,
  },
  {
    name: 'Active calls',
    link: '/active-calls/',
    icon: <SquareIcon />,
  },
];

export default pages;
